import { ClientsLinkPermissions } from "@lib/types/clients-links.types";
import {
  CLIENT_VIEW_EVENT_CHAT_ROUTE,
  CLIENT_VIEW_EVENT_CONSULTATION_FORM_COMPLETE_ROUTE,
  CLIENT_VIEW_EVENT_CONSULTATION_FORM_ROUTE,
  CLIENT_VIEW_EVENT_INVOICE_ROUTE,
  CLIENT_VIEW_EVENT_MENU_ROUTE,
  CLIENT_VIEW_EVENT_PAYMENT_INVOICE_ROUTE,
  CLIENT_VIEW_EVENT_PAYMENT_PROPOSAL_ROUTE,
  CLIENT_VIEW_EVENT_PROPOSAL_ROUTE,
} from "./routes";

export const CLIENTS_LINK_RESOURCE_ACCESS_MAP: Record<
  string,
  ClientsLinkPermissions[]
> = {
  [CLIENT_VIEW_EVENT_MENU_ROUTE]: ["event-menu"],
  [CLIENT_VIEW_EVENT_CONSULTATION_FORM_ROUTE]: ["event-consultation-form"],
  [CLIENT_VIEW_EVENT_CONSULTATION_FORM_COMPLETE_ROUTE]: [
    "event-consultation-form",
  ],
  [CLIENT_VIEW_EVENT_PROPOSAL_ROUTE]: ["event-proposal"],
  [CLIENT_VIEW_EVENT_PAYMENT_PROPOSAL_ROUTE]: ["event-proposal"],
  [CLIENT_VIEW_EVENT_INVOICE_ROUTE]: ["event-invoice"],
  [CLIENT_VIEW_EVENT_PAYMENT_INVOICE_ROUTE]: ["event-invoice"],
  [CLIENT_VIEW_EVENT_CHAT_ROUTE]: ["event-chat"],
};

export const CLIENTS_LINK_PERMISSIONS = [
  "event-chat",
  "event-menu",
  "event-consultation-form",
  "event-proposal",
  "event-invoice",
] as const;
